// Admin-configurable upload content categories. The Form Groups admin stores a
// category key on a file field (`field.accept`); AddFormV1/EditFormV1 expand it
// to the browser `accept` attribute and a beforeUpload extension check, so a
// file outside the category is rejected client-side with a clear message.
// A field without a category (or 'any') falls back to the fine-grained
// `fileType` validation rule, preserving existing behaviour.

const IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'avif'];
// Mirrors DocumentViewer's VIDEO_EXT so anything uploadable is also previewable.
const VIDEO_EXTS = ['mp4', 'webm', 'ogg', 'ogv', 'mov', 'm4v'];
const DOC_EXTS = ['pdf', 'doc', 'docx'];

export const UPLOAD_ACCEPT_OPTIONS = [
  { label: 'Any file', value: 'any' },
  { label: 'Documents & Images (pdf, doc, images)', value: 'documents' },
  { label: 'Images only', value: 'images' },
  { label: 'Videos only', value: 'videos' },
  { label: 'Images & Videos', value: 'imagesAndVideos' },
];

export const UPLOAD_ACCEPT_CATEGORIES = {
  documents: {
    exts: [...DOC_EXTS, ...IMAGE_EXTS],
    hint: 'PDF, DOC or image files',
    error: 'Only document (PDF/DOC) or image files are allowed',
  },
  images: {
    exts: IMAGE_EXTS,
    hint: 'Image files',
    error: 'Only image files are allowed',
  },
  videos: {
    exts: VIDEO_EXTS,
    hint: 'Video files',
    error: 'Only video files are allowed',
  },
  imagesAndVideos: {
    exts: [...IMAGE_EXTS, ...VIDEO_EXTS],
    hint: 'Image or video files',
    error: 'Only image or video files are allowed',
  },
};

// uploadAcceptCategory resolves a field's configured category, or null when the
// field accepts any file ('any', unset, or an unknown key).
export function uploadAcceptCategory(field) {
  return UPLOAD_ACCEPT_CATEGORIES[String(field?.accept ?? '').trim()] ?? null;
}
